import React from 'react';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-white">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-gray-50 to-white opacity-50" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-gradient-to-r from-gray-100 to-gray-200 opacity-30 blur-3xl" />
      </div>

      <div className="container relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 tracking-tight">
            Revolutionizing
            <span className="block mt-2 gradient-text">Payment Orchestration</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-600 mb-12 max-w-2xl mx-auto">
            Empowering businesses with seamless, intelligent payment solutions
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="https://tally.so/r/3ykrZ6" className="btn-primary w-full sm:w-auto">
              Get Started
            </a>
            <a href="#features" className="px-6 py-3 border-2 border-black rounded-lg transform transition-all duration-300 hover:scale-105 hover:shadow-lg w-full sm:w-auto">
              Learn More
            </a>
          </div>

          {/* Stats */}
          <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">300+</div>
              <div className="text-gray-600">Payment Providers</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">50%</div>
              <div className="text-gray-600">Cost Reduction</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">75%</div>
              <div className="text-gray-600">Less Engineering</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">30%</div>
              <div className="text-gray-600">Revenue Recovery</div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-white to-transparent" />
    </section>
  );
};

export default Hero; 